import feathers from '@feathersjs/feathers';
import rest from '@feathersjs/rest-client';
import config from './config';

const client = feathers();
const restClient = rest(config.api);
client.configure(restClient.fetch(window.fetch));

export default client;